import TypeOfAccountRequired from "@/layouts/auth/components/TypeOfAccountRequired";
import UserProfile from "@/layouts/navigation/user-profile";
import ProfileArtists from "@/pages/profile/artists";
import ProfileArtlists from "@/pages/profile/artlists";
import ProfileArtworks from "@/pages/profile/artworks";
import ProfileArtworkDrafts from "@/pages/profile/artworks-drafts";
import ProfileBoard from "@/pages/profile/board";
import BoardLayout from "@/pages/profile/board/BoardLayout";
import ProfileCollection from "@/pages/profile/collection";
import ProfileCommunity from "@/pages/profile/community";
import DraftList from "@/pages/profile/drafts/components/DraftList";
import ProfileRedirect from "@/pages/profile/profile-redirect";
import ArticleWrapper from "@/shared-components/forms/add-board-content/add-article/ArticleWrapper";
import Post from "@/shared-components/forms/add-board-content/add-post/post";

const InternalProfileRoutes = [
  {
    path: "/profile",
    element: <UserProfile internal />,
    children: [
      {
        element: <TypeOfAccountRequired allowedTypes={["artist", "collector"]} />,
        children: [
          { path: "/profile/collection", element: <ProfileCollection /> },
          { path: "/profile/community", element: <ProfileCommunity /> },
        ]
      },

      {
        element: <TypeOfAccountRequired allowedTypes={["gallery"]} />,
        children: [
          { path: "/profile/artworks/drafts", element: <ProfileArtworkDrafts/> },
          { path: "/profile/artists", element: <ProfileArtists/> },
        ]
      },

      {
        element: <TypeOfAccountRequired allowedTypes={["artist", "gallery"]} />,
        children: [
          { path: "/profile/artworks", element: <ProfileArtworks/> },
        ]
      },

      {
        element: <TypeOfAccountRequired allowedTypes={["artist", "gallery", "collector"]} />,
        children: [
          {
            path: "board",
            element: <BoardLayout/>,
            children: [
              { index: true, element: <ProfileBoard/> },
              { path: "post/:postId",    element: <Post/> },
              { path: "article/:articleId", element: <ArticleWrapper/> },
              { path: "drafts",           element: <DraftList /> },
            ]
          },
        ]
      },

      { path: "/profile/artlists", element: <ProfileArtlists /> },
      
      // Optionally, you could add a redirect or placeholder route here if needed.
    ]
  }
];

const ExternalProfileRoutes = [
  {
    path: "/user/:username",
    element: <UserProfile />,
    children: [
      { index: true, element: <ProfileRedirect/> },
      { path: "/user/:username/artworks", element: <ProfileArtworks/> },
      { path: "/user/:username/collection", element: <ProfileCollection/> },
      { path: "/user/:username/artists", element: <ProfileArtists/> },
      { path: "/user/:username/artlists", element: <ProfileArtlists/> },
      {
        path: "board", // nested under /user/:username
        element: <BoardLayout/>,
        children: [
          { index: true, element: <ProfileBoard/> },
          { path: "post/:postId", element: <Post/> },
          { path: "article/:articleId", element: <ArticleWrapper/> },
          { path: "drafts", element: <DraftList /> }
        ]
      },
      { path: "/user/:username/community", element: <ProfileCommunity/> },
    ]
  }
];

export {
  InternalProfileRoutes,
  ExternalProfileRoutes
};
